import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div className="page page--center">
      <h1>404</h1>
      <p>That page doesn’t exist (or hasn’t been written yet).</p>
      <Link to="/" className="btn btn--primary">Back home</Link>
    </div>
  );
}
